//node_modules
import React from "react";
import { NextPage } from "next";
import { Button, Card, Container } from "react-bootstrap";

//layout
import SiteLayout from "src/layouts/SiteLayout";

//components
import PageHeaderComponent from "src/components/PageHeaderComponent";

//locals
import QuestionComponent from "./components/QuestionComponent";
import MetaComponent from "./components/MetaDataComponent";

//data
import questions from "./questions";

const FaqPage: NextPage<any> = () => {
  return (
    <SiteLayout>
      <MetaComponent />
      <Container className="my-5">
        <PageHeaderComponent type="h1" className="text-center mb-4">
          Frequently Asked Questions
        </PageHeaderComponent>
        <p className="lead text-center mx-auto mb-5" style={{ maxWidth: 700 }}>
          Planning a vacation should be exciting—not overwhelming. Here are answers to some of the questions we're asked most often.
        </p>
        {questions.map((question, i) => (
          <QuestionComponent key={i} question={question} />
        ))}
        <Card className="text-center border-0 bg-light mt-5 p-5">
          <h2>Didn't find your answer?</h2>

          <p className="lead">We'd love to help.</p>

          <Button size="lg" href="/contact/">
            Contact a Travel Advisor
          </Button>
        </Card>
      </Container>
    </SiteLayout>
  );
};

export default FaqPage;
